import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../../config/config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function MetaTagsDetailComponent() {
  const { Id } = useParams();
  const navigate = useNavigate();

  const [metaTag, setMetaTag] = useState({
    id: '',
    page: '',
    title: '',
    description: '',
    keywords: '',
    author: '',
    copyright: '',
    cache_control: '',
    distribution: '',
    document_distribution: '',
    document_rating: '',
    document_rights: '',
    document_state: '',
    publisher: '',
    rating: '',
    expires: '',
    resource_type: '',
    Address: '',
    robots: '',
    og_title: '',
    og_url: '',
    og_description: '',
    og_type: '',
    og_site_name: '',
    og_street_address: '',
    og_locality: '',
    og_region: '',
    og_country_name: '',
    og_email: '',
    og_phone_number: '',
    og_image: '' // New field for image URL
  });
  
  const [ogImage, setOgImage] = useState(null);
  
  useEffect(() => {
    const fetchMetaTag = async () => {
      try {
        const response = await axios.get(`${config.API_BASE_URL}/get_individual_page_meta_tags2.php?id=${Id}`);
        const data = response.data;
  
        if (data.success) {
          const { created_at, updated_at, deleted_at, ...filteredData } = data.metaTag;
          setMetaTag(filteredData);
  
          // Set the OG image to state if it exists
          setOgImage(data.metaTag.og_image || null);
        } else {
          toast.error(data.message || 'Failed to fetch meta tag details.');
        }
      } catch (error) {
        toast.error('An error occurred while fetching the meta tag.');
      }
    };
  
    fetchMetaTag();
  }, [Id]);
  
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMetaTag((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setOgImage(e.target.files[0]);
  };

  const handleUpdate = async () => {
    const formData = new FormData();
    
    // Append all meta tag fields to FormData
    Object.keys(metaTag).forEach((key) => {
      formData.append(key, metaTag[key]);
    });

    // Append the image file if selected
    if (ogImage) {
      formData.append('og_image', ogImage);
    }

    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/update-meta-tag.php`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      );

      if (response.data.success) {
        toast.success('Meta tag updated successfully!');
        navigate('/admin/meta-tags');
      } else {
        toast.error(response.data.message || 'Failed to update meta tag.');
      }
    } catch (error) {
      toast.error('An error occurred while updating the meta tag.');
    }
  };

  return (
    <div className="container-fluid meta_detail">
      <h1>Edit Meta Tag</h1>
      <div className="form-group">

        <input type="hidden" name="id" value={metaTag.id} />

        <div className='form-group'>
          <label>Page:</label>
          <input type="text" name="page" value={metaTag.page} readOnly />
        </div>

        {Object.keys(metaTag).map((key) => (
          (key !== 'id' && key !== 'page' && key !== 'og_image') && (
            <div key={key} className='form-group'>
              <label>{key.replace(/_/g, ' ').toUpperCase()}:</label>
              <input type="text" name={key} value={metaTag[key]} onChange={handleChange} />
            </div>
          )
        ))}

        {/* OG Image Upload Field */}
        <div className="form-group">
          <label>OG Image (1200 x 630 px):</label>
          <input type="file" accept="image/*" onChange={handleFileChange} />
        </div>

        <button onClick={handleUpdate}>Update</button>
      </div>

      <ToastContainer />
    </div>
  );
}

export default MetaTagsDetailComponent;
